export default {
  appointmentConfirmation: 60 * 48,
};
